import { Fragment, type ReactNode } from 'react';
import { Card } from '../../components/Card';
import { DescriptionList, DescriptionTerm, DescriptionDetails } from '../../catalyst/description-list';
import { SourceBlock } from './SourceBlock';

export interface SourceCardSource {
  label?: string;
  esn?: string;
  documentId: string;
  pageIds: string[];
}

interface SourceCardProps {
  sources: Array<SourceCardSource | false | null | undefined>;
  children?: ReactNode;
}

export function SourceCard({ sources, children }: SourceCardProps) {
  const items = sources.filter((source): source is SourceCardSource => Boolean(source));

  if (items.length === 0) {
    return null;
  }

  const isSingleUnlabeled = items.length === 1 && !items[0].label;

  return (
    <Card header={<h2 className="text-lg font-medium text-gray-900 dark:text-zinc-100">Source</h2>}>
      {isSingleUnlabeled ? (
        <SourceBlock esn={items[0].esn} documentId={items[0].documentId} pageIds={items[0].pageIds} />
      ) : (
        <DescriptionList>
          {items.map((source, index) => (
            <Fragment key={source.label ?? index}>
              <DescriptionTerm>{source.label ?? 'Source'}</DescriptionTerm>
              <DescriptionDetails>
                <SourceBlock esn={source.esn} documentId={source.documentId} pageIds={source.pageIds} />
              </DescriptionDetails>
            </Fragment>
          ))}
        </DescriptionList>
      )}
      {children}
    </Card>
  );
}
